var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 18.7C9.35833 19 8.83333 19.1083 8.3 19.025C7.78333 18.925 7.35 18.675 7 18.275C6.66667 17.8583 6.5 17.3583 6.5 16.775V7.225C6.5 6.64167 6.66667 6.15 7 5.75C7.35 5.33333 7.78333 5.08333 8.3 5C8.83333 4.9 9.35833 4.99167 9.875 5.275L18.125 10.05C18.6417 10.35 18.9917 10.75 19.175 11.25C19.3583 11.75 19.3583 12.25 19.175 12.75C18.9917 13.25 18.6417 13.6417 18.125 13.925L9.875 18.7ZM8.5 17.625C8.5 17.775 8.44167 17.85 8.325 17.85C8.20833 17.8333 8.11667 17.775 8.05 17.675C7.98333 17.575 8.01667 17.4917 8.15 17.425L17.85 11.775C18 11.6917 18.1 11.7083 18.15 11.825C18.2 11.9417 18.2 12.0583 18.15 12.175C18.1 12.2917 18 12.3083 17.85 12.225L8.15 6.575C8.01667 6.50833 7.98333 6.425 8.05 6.325C8.11667 6.225 8.20833 6.16667 8.325 6.15C8.44167 6.13333 8.5 6.20833 8.5 6.375V17.625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayOutlined);
export default __webpack_public_path__ + "static/media/play_outlined.263b5753.svg";
export { ForwardRef as ReactComponent };